export default "__VITE_ASSET__B2qz5Ld8__"